import React from 'react';

const ChatWindow = ({ chatRef, messages, visitorName, renderComponent, isChuckMode }) => {
    return (
        <div
            ref={chatRef}
            className="h-[calc(100vh-12rem)] sm:h-[calc(80vh-12rem)] overflow-y-auto p-4 font-mono text-sm bg-gradient-to-b from-cyber-black/90 to-cyber-gray/10 backdrop-blur-sm"
        >
            {messages.map((msg) => (
                <div key={msg.id} className="mb-4">
                    <div className="flex items-center text-primary/80">
                        {msg.sender === "user" ? (
                            <>
                                <span className="text-primary">{visitorName}</span>
                                <span className="text-primary/60">:~$ </span>
                            </>
                        ) : (
                            <span className="text-yellow-500">
                                {isChuckMode && (
                                    <img src="/images/chuck.png" alt="Chuck Norris" className="inline-block w-6 h-6 mr-2" />
                                )}
                                system@fccview:~$ 
                            </span>
                        )}
                    </div>
                    <div className={`mt-1 text-gray-300 whitespace-pre-line`}>
                        {msg.sender !== "ai" ? <span className="text-primary/60">{`> `}</span> : <span className="text-yellow-500">{'>'} </span>} {msg.displayText}
                        {msg.sender === "ai" && msg.displayText !== (typeof msg.text === 'object' ? msg.text.text : msg.text) && (
                            <span className="animate-pulse">▊</span>
                        )}
                    </div>
                    {msg.sender === "ai" &&
                        msg.component &&
                        msg.displayText === (typeof msg.text === 'object' ? msg.text.text : msg.text) && (
                            <div className="mt-4">
                                {renderComponent(msg.component)}
                            </div>
                        )}
                </div>
            ))}
        </div>
    );
};

export default ChatWindow; 